class FurseraPurchaseAssurance extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.backdrop = this.querySelector('[data-backdrop]');
    this.onKeydown = (event) => { if (event.key === 'Escape') this.close(); };
    this.querySelectorAll('[data-open]').forEach((button) => {
      button.addEventListener('click', () => this.open(button.dataset.open, button));
    });
    this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    this.backdrop?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() { document.removeEventListener('keydown', this.onKeydown); }

  open(name, trigger) {
    const drawer = this.querySelector(`[data-drawer="${name}"]`);
    if (!drawer) return;
    this.close(false);
    this.activeDrawer = drawer;
    this.lastTrigger = trigger;
    if (this.backdrop) this.backdrop.hidden = false;
    drawer.hidden = false;
    document.body.classList.add('fursera-assurance-open');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    drawer.querySelector('[data-close]:last-of-type')?.focus();
  }

  close(restoreFocus = true) {
    if (!this.activeDrawer) return;
    const drawer = this.activeDrawer;
    drawer.classList.remove('is-open');
    this.activeDrawer = null;
    document.body.classList.remove('fursera-assurance-open');
    if (this.backdrop) this.backdrop.hidden = true;
    window.setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 250);
    if (restoreFocus) this.lastTrigger?.focus();
  }
}

if (!customElements.get('fursera-purchase-assurance')) customElements.define('fursera-purchase-assurance', FurseraPurchaseAssurance);
